var _defs, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_42097",
    "data-name": "Group 42097",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path99",
    d: "M0-682.665H14v14H0Z",
    transform: "translate(0 682.665)"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14942",
    "data-name": "Rectangle 14942",
    width: 16,
    height: 16,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g93",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g95"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g97",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g103",
    transform: "translate(1.557 0.41)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path105",
    d: "M-259.968-626.873s5.443-3.191,5.443-7.682A5.443,5.443,0,0,0-259.968-640a5.443,5.443,0,0,0-5.443,5.443C-265.411-630.065-259.968-626.873-259.968-626.873Z",
    transform: "translate(265.411 639.998)",
    fill: "none",
    stroke: "#b2b9c4",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g107",
    transform: "translate(5.021 3.789)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path109",
    d: "M-189.083-94.542a1.979,1.979,0,0,1-1.979,1.979,1.979,1.979,0,0,1-1.979-1.979,1.979,1.979,0,0,1,1.979-1.979A1.979,1.979,0,0,1-189.083-94.542Z",
    transform: "translate(193.042 96.521)",
    fill: "none",
    stroke: "#b2b9c4",
    strokeWidth: 1
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapMarker);
export default __webpack_public_path__ + "static/media/map-marker.a976de2be626702fa72f2b75d8e5e455.svg";
export { ForwardRef as ReactComponent };